var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"clearfix"},[_c('div',{staticClass:"message-data text-right"},[_c('span',{staticClass:"message-data-time"},[_vm._v(_vm._s(_vm.dateOutput))])]),_vm._v(" "),_c('div',{staticClass:"message",class:_vm.event.representative ? 'other-message float-right' : 'my-message'},[_vm._v("\n        "+_vm._s(_vm.event.messageText)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }